'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _RhumbContext = require('./internal/RhumbContext');

var _RhumbContext2 = _interopRequireDefault(_RhumbContext);

var _ActionTypes = require('./internal/ActionTypes');

var ActionTypes = _interopRequireWildcard(_ActionTypes);

var _Scheduler = require('./internal/Scheduler');

var _performanceNow = require('./vendor/performanceNow');

var _performanceNow2 = _interopRequireDefault(_performanceNow);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useNavMarker = function useNavMarker(name) {
  var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var context = (0, _react.useContext)(_RhumbContext2.default);

  var id = context && context.id;
  var dispatch = context && context.dispatch;
  var enabled = active && typeof context !== 'undefined';

  (0, _react.useEffect)(
  // eslint-disable-next-line consistent-return
  function () {
    if (enabled) {
      var marker = {
        name: name,
        id: id
      };

      var timestamp = (0, _performanceNow2.default)();

      (0, _Scheduler.runWithLowPriority)(function () {
        dispatch({
          type: ActionTypes.MARKER_MOUNTED,
          payload: {
            marker: marker,
            timestamp: timestamp
          }
        });
      });

      // eslint-disable-next-line consistent-return
      return function () {
        (0, _Scheduler.runWithLowPriority)(function () {
          dispatch({
            type: ActionTypes.MARKER_UNMOUNTED,
            payload: {
              marker: marker
            }
          });
        });
      };
    }
  },
  // dispatch is guaranteed to be static
  [name, id, dispatch, enabled]);
};

exports.default = useNavMarker;
module.exports = exports['default'];